/**
 * Tiny client-side CSV exporter. Builds a CSV string from a header row plus
 * an array of cell-arrays, then triggers a browser download. No dependency,
 * no backend round-trip — the data is already in memory from React Query.
 */
function escapeCell(value: string | number): string {
  const s = String(value);
  // Quote when the cell contains a comma, quote, or newline; double internal quotes.
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCsv(filename: string, header: string[], rows: (string | number)[][]): void {
  const lines = [header, ...rows].map((cols) => cols.map(escapeCell).join(','));
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
